import { readBackendAuthPayload } from '@/lib/auth/backendAuthResponse'

type AdminVerifyPayload<TUser> = {
  success?: unknown
  authFailure?: unknown
  user?: TUser | null
}

export type AdminVerifyResult<TUser> =
  | { success: true; user?: TUser | null }
  | { success: false; authFailure: boolean }

export async function classifyAdminVerifyResponse<TUser>(
  response: Response
): Promise<AdminVerifyResult<TUser>> {
  const payload =
    await readBackendAuthPayload<AdminVerifyPayload<TUser>>(response)

  if (response.ok && payload?.success === true) {
    return { success: true, user: payload.user ?? null }
  }

  return {
    success: false,
    authFailure: payload?.authFailure === true,
  }
}
